import useStorage from "hooks/useStorage"
import { useEffect, useContext } from "react"
import SubmitButton from "./SubmitButton"
import ItemList from "./ItemList"
import CategorySelector from "./Categories/CategorySelector"
import { AppParamsContext } from "contexts/AppParamsContext"
import { BasketContext } from "contexts/BasketContext"
import { isDesktop } from "react-device-detect"

export default function OrderItems({ readOnly }) {
  const { appParams } = useContext(AppParamsContext)
  const { getSV, removeSV } = useStorage()

  const {
    selectedSubCategory,
    setSelectedSubCategory,
    selectedCategory,
    setSelectedCategory,
  } = useContext(BasketContext)

  useEffect(() => {
    setSelectedSubCategory("")
    if (selectedCategory) {
      // if (readOnly) {
      //   navigate(`/menu?categoryUUID=${selectedCategory}`);
      // } else {
      //   navigate(`/order?categoryUUID=${selectedCategory}`);
      // }
    }
    //eslint-disable-next-line
  }, [selectedCategory])

  useEffect(() => {
    if (getSV("selectedCategory") != null) {
      setSelectedCategory(getSV("selectedCategory"))
      removeSV("selectedCategory")
    }
    const searchparams = new URLSearchParams(window.location.search)
    if (searchparams.get("categoryUUID") != null) {
      setSelectedCategory(searchparams.get("categoryUUID"))
    }
    // eslint-disable-next-line
  }, [])

  return (
    <div
      className={`orderItems-root hidden-content appear ${appParams?.features?.orderLocationSelector === false
        ? "no-location-selector"
        : ""
        } ${isDesktop ? "p-2" : ""}`}
    >
      {!(
        appParams?.features?.selectedCategoryItemsOnly ||
        appParams?.order?.selectedCategoryItemsOnly
      ) && (
          <CategorySelector
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
          />
        )}
      <ItemList
        readOnly={readOnly}
        selectedCategory={selectedCategory}
        selectedSubCategory={selectedSubCategory}
        setSelectedCategory={setSelectedCategory}
        setSelectedSubCategory={setSelectedSubCategory}
      />
      {!readOnly && !isDesktop && <SubmitButton />}
    </div>
  )
}
